import { render, staticRenderFns } from "./CowsLIstPage.vue?vue&type=template&id=ab19fa0a&scoped=true&"
import script from "./CowsLIstPage.vue?vue&type=script&lang=js&"
export * from "./CowsLIstPage.vue?vue&type=script&lang=js&"
import style0 from "./CowsLIstPage.vue?vue&type=style&index=0&id=ab19fa0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab19fa0a",
  null
  
)

export default component.exports